import { render, staticRenderFns } from "./LookupInstitution.vue?vue&type=template&id=bcc3d756"
import script from "./LookupInstitution.vue?vue&type=script&lang=js"
export * from "./LookupInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports